import React, { Component } from "react"
import PropTypes from "prop-types"
import styled from "styled-components"
import { getStyledSecondaryColor, getStyledPrimaryColor } from "theme/palette"

const ProgressBarWrapper = styled.div`
  background: ${getStyledPrimaryColor("progressBg")};
  border-radius: 3px;
  height: 12px;
  overflow: hidden;
  position: relative;
  width: 100%;
`

const ProgressBar = styled.div`
  background: ${getStyledPrimaryColor("progressBar")};
  border-radius: 3px;
  content: "";
  height: 100%;
  left: 0;
  position: absolute;
  top: 0;
  width: 100%;

  transform-origin: left;
  will-change: transform;
`

class ProgressBarComponent extends Component {
  el = React.createRef()

  handleClick = (event) => {
    if (!this.el.current) {
      return
    }
    const { width, x } = this.el.current.getBoundingClientRect()

    if (width === 0) {
      this.props.onSeek(0)
      return
    }

    this.props.onSeek(Math.floor((event.pageX - x) / width * 100))
  }

  render() {
    const { value, theme } = this.props

    return (
      <ProgressBarWrapper theme={theme} innerRef={this.el} onClick={this.handleClick}>
        <ProgressBar theme={theme} style={{ transform: `scaleX(${value.toFixed(5) / 100})` }} />
      </ProgressBarWrapper>
    )
  }
}

ProgressBarComponent.propTypes = {
  value: PropTypes.number.isRequired,
  theme: PropTypes.oneOf(["light", "dark"]),
  onSeek: PropTypes.func.isRequired,
}

ProgressBarComponent.defaultProps = {
  theme: "light",
  value: 0,
}

export default ProgressBarComponent



// WEBPACK FOOTER //
// ./src/components/atoms/ProgressBar/index.js